<template>
  <base-modal>
    <template slot="default" slot-scope="{ is_button_loading }">
      <div class="connection-modal__row">
        <i-button
          v-bind="base_button_props"
          type="error"
          icon="md-close"
          :loading="is_loading(is_button_loading, 'no')"
          :disabled="is_disabled('no')"
          @click="set_value('no')"
        />
        <i-button
          v-bind="base_button_props"
          type="success"
          icon="md-checkmark"
          :loading="is_loading(is_button_loading, 'yes')"
          :disabled="is_disabled('yes')"
          @click="set_value('yes')"
        />
      </div>
    </template>
  </base-modal>
</template>

<script>
  import BaseModal from '../_base';

  export default {
    components: { BaseModal },
    props: {
      box: {
        type: Object,
        require: true,
        default: () => ({})
      }
    },

    data() {
      return {
        current_value: '',
        base_button_props: {
          ghost: true,
          long: true,
          size: 'large'
        }
      };
    },

    methods: {
      is_disabled: function(type) {
        const free_options = Object.keys(this.box.getFreeOptions());
        return !free_options.includes(type);
      },

      is_loading: function(is_button_loading, type) {
        return is_button_loading && type === this.current_value;
      },

      set_value: function(value) {
        this.current_value = value;
        this.$emit('confirm', this.current_value);
      }
    }
  };
</script>
